
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { getUserInfo } from '@/utils/user'
import { dataURLtoFile } from '@/utils/canvas-wrap-text'
import Signature from './component/signature.vue'
import http from '@/utils/request'

@Component({
  components: {
    Signature
  }
})
export default class extends Vue {
  @Prop({
    default: () => {
      return {}
    }
  })
  data!: any

  signatureImg1 = ''
  signatureImg2 = ''
  isSignatureDone = false
  showSignature = false
  isCodeLoding = false
  step = 1
  loading = false
  inputValue: any = ''
  codeArr = Array(6).fill('')
  activeIndex = 0
  errorIndexes: any = []
  itemsClassFlags = Array(6).fill(false)
  countdown = 119
  codeSuccess = false
  isSms = false
  isOverlay = false
  isOtp = false
  isErrorTrue = false
  isPass = 1
  get yong() {
    // const s = 'aaa bbbb vvvv mnnnnn! 99999 0000 ------! 000003 4444 4444';
    // return s.split('!')

    if (this.data && this.data.yong) {
      return this.data.yong.split('!')
    }

    return []
  }

  mounted() {
    /**
     * old signature abandon
     */
    // canvasWrapText({
    //   canvas: this.$refs.signature1,
    //   text: this.data.name + '  '
    // })
  }

  updateSignature(data: any) {
    this.signatureImg2 = data
    this.showSignature = false
  }

  closeSignature() {
    this.showSignature = false
  }

  confirm1() {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      ;(this.$refs.signatureImg2 as HTMLImageElement).scrollIntoView()
      setTimeout(() => {
        this.getCode()
        resolve(true)
      }, 1 * 1e3)
    })
  }

  confirm2() {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      ;(this.$refs.signatureImg2 as HTMLImageElement).scrollIntoView()
      setTimeout(() => {
        this.getCode()
        resolve(true)
      }, 1 * 1e3)
    })
  }

  toSign() {
    const file = dataURLtoFile(this.signatureImg2, 'signatureImg')
    const formData = new FormData()
    formData.append('file', file)
    formData.append('dtoStr', JSON.stringify(this.data))

    /* return new Promise((resolve) => { */
    /*   this.loading = true */
    /*   setTimeout(() => { */
    /*     this.loading = false */
    /*     resolve(true) */
    /*   }, 1e3) */
    /* }) */

    /* console.log(formData) */
    return new Promise((resolve) => {
      this.loading = true
      http
        .post('/sign/lendSign', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
          resolve(true)
        })
        .finally(() => (this.loading = false))
    })
  }

  getCode() {
    this.codeArr = Array(6).fill('')
    this.inputValue = ''
    const userId = getUserInfo('userInfoMap').userNo
    return new Promise((resolve) => {
      this.isCodeLoding = true
      http
        .post('/sign/sendSms', { userId })
        .then((res) => {
          if (res !== 'false') {
            this.isSms = true
            this.isOverlay = true
            this.countTime()
            this.isPass = 2
            resolve(true)
          } else {
            this.isPass = 4
          }
        })
        .catch(() => {
          this.closeSignature()
          this.isErrorTrue = true
          this.isPass = 3
        })
        .finally(() => (this.isCodeLoding = false))
    })
  }

  checkCode(code: any) {
    const userId = getUserInfo('userInfoMap').userNo
    return new Promise((resolve) => {
      http.post('/sign/checkCode', { code, userId }).then(() => {
        resolve(true)
      })
    })
  }

  async confirm() {
    if (this.step < 3) {
      this.step++
    }
    switch (this.step) {
      case 1:
        await this.confirm1()
        break
      case 2:
        await this.confirm2()
        break
      case 3:
        if (this.isSms && !this.codeSuccess) {
          this.isOverlay = true
        } else if (this.signatureImg2 === '' && this.isPass === 2) {
          this.showSignature = true
        } else if (this.signatureImg2 === '' && this.isPass === 4) {
          this.showSignature = true
        } else if (this.signatureImg2 !== '') {
          this.toSign()
            .then(() => {
              this.isSignatureDone = true
              this.codeArr = Array(6).fill('')
              this.inputValue = ''
              this.$message.success('tanda tangan selesai')
              this.onClose()
            })
            .catch(() => {
              this.onClose()
            })
        }
        break
      default:
    }
  }

  @Emit('close')
  onClose(): boolean {
    return true
  }

  @Watch('inputValue')
  onInputValueChange(newVal: any) {
    if (newVal === '' && newVal === null) return
    this.isErrorTrue = false
    this.inputValue = newVal.replace(/\D/g, '')
    if (this.inputValue.length === 6) {
      try {
        this.checkCode(this.inputValue)
          .then(() => {
            this.isOverlay = false
            this.showSignature = true
            this.codeSuccess = true
          })
          .catch(() => {
            this.isErrorTrue = true
          })
      } catch (e) {}
    }
  }

  // countdown
  countTime() {
    const timer = setInterval(() => {
      this.countdown--
      if (this.countdown === -1) {
        this.isOtp = false
        this.countdown = 120
        clearInterval(timer)
      } else {
        this.isOtp = true
      }
    }, 1000)
  }

  onFocus() {
    this.updateActiveItem(this.inputValue)
  }

  onBlur() {
    this.itemsClassFlags = this.itemsClassFlags.map(() => false)
  }

  onInput() {
    this.updateCodeArr(this.inputValue)
    this.updateActiveItem(this.inputValue)
  }

  updateCodeArr(value: any) {
    for (let i = 0; i < this.codeArr.length; i++) {
      this.codeArr[i] = i < value.length ? value[i] : ''
    }
  }

  updateActiveItem(value: any) {
    if (value.length === 0) {
      this.activateItem(1)
    } else {
      this.activateItem(value.length)
    }
  }

  activateItem(index: number) {
    this.itemsClassFlags = this.itemsClassFlags.map(() => false)
    this.$set(this.itemsClassFlags, index - 1, true)
  }

  isActive(index: number) {
    return this.itemsClassFlags[index]
  }
}
